import { FunctionComponent } from "react";
import { deleteWhatson, Whatson, WhatsonApiPayload, fetchWhatson, setStatus } from "../whatsonSlice";
import { useAppDispatch } from "../../../app/hooks";
import { useAuth } from "react-oidc-context";
import { Link, useNavigate } from "react-router";
import { isFulfilled } from "@reduxjs/toolkit";
import styled from 'styled-components';

export const Wrapper = styled.article<{
  cols: string
}>`
  display: grid;
  grid-template-columns: ${props => props.cols};

  .listed-item, .next-listed-item, .last-listed-item {
    color: var(--black);
    padding-left: 1rem;
  }

  .listed-item {
    border-bottom: 1px solid var(--black);
  }
  .next-listed-item {
    border-left: 1px solid var(--black);
  }

  .odd-item {
    background: rgba(188,230,236,1)
  }

  .white-backgrounded-button {
    color: var(--nighttime);
    border: 1px solid var(--nighttime);
  }

  .white-backgrounded-a-text {
    color: var(--black);
  }
`
/**
 * 
 * 
 * @returns a flexible event card, sensitive to the display width
 */

type WhatsonCardSummaryParams = {
  key: string
  whatson: Whatson
  isOdd: boolean
  isLast: boolean
}

export const WhatsonCardSummary: FunctionComponent<WhatsonCardSummaryParams> = ({whatson, isOdd, isLast}) => {
  const dispatch = useAppDispatch();
  const auth = useAuth();
  const navigate = useNavigate();


  const handleEdit = async () => {

    dispatch(setStatus('pending'))

    // use returned value to ensure that dispatch finishes
    const action = await dispatch(fetchWhatson({id: whatson.id} as WhatsonApiPayload))
    if (isFulfilled(action)) {
      navigate(`/schedule-edit-development-894313412/${whatson.id}`)
    }
  }
  const handleDelete = async () => {
    const action = await dispatch(deleteWhatson({accessToken: auth.user?.access_token as string, id: whatson.id} as WhatsonApiPayload))
    if (isFulfilled(action)) {
      await dispatch(fetchWhatson({id: whatson.id} as WhatsonApiPayload))
    }
    
  }

  return (
    <Wrapper cols={auth.isAuthenticated ? '100px 100px 160px 250px 70px 1fr 130px' : '100px 100px 160px 250px 70px 1fr'}>
        <div className={`truncated-text-container pad-top-bot ${isLast ? 'last-' : ''}listed-item ${isOdd ? 'odd-item' : ''}`}>{whatson.day}</div>
        <div className={`truncated-text-container pad-top-bot ${isLast ? 'last-' : ''}listed-item next-listed-item ${isOdd ? 'odd-item' : ''}`}>{whatson.start}</div>
        <div className={`truncated-text-container pad-top-bot ${isLast ? 'last-' : ''}listed-item next-listed-item ${isOdd ? 'odd-item' : ''}`}>{whatson.location}</div>
        <div className={`truncated-text-container pad-top-bot ${isLast ? 'last-' : ''}listed-item next-listed-item ${isOdd ? 'odd-item' : ''}`}>{whatson.vendor}</div>
        <div className={`truncated-text-container pad-top-bot ${isLast ? 'last-' : ''}listed-item next-listed-item ${isOdd ? 'odd-item' : ''}`}>{whatson.minAge}</div>
        <div className={`truncated-text-container pad-top-bot ${isLast ? 'last-' : ''}listed-item next-listed-item ${isOdd ? 'odd-item' : ''}`}>{whatson.title}</div>

  

          { auth.isAuthenticated && (
            <div className="right-align-container" style={{minWidth: '160px'}}>
              <button
                type='button'
                className='btn white-backgrounded-button'
                onClick={() => handleEdit()}
              >
                Edit
              </button>
              <button
                type='button'
                className='btn btn-danger'
                onClick={() => handleDelete()}
              >
                Delete
              </button>
            </div>
          )}
   

    </Wrapper>
  )
}